/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
import React from 'react';
import clsx from 'clsx';
// BASE Components
import BASENavigation from '../../../@BASE/core/BASENavigation';
import BASESvgIcon from '../../../@BASE/core/BASESvgIcon';
// Material UI Components
import { alpha, styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Hidden from '@mui/material/Hidden';
import IconButton from '@mui/material/IconButton';
// Custom Components
import SettingsNavigation from './SettingsNavigation';

const Root = styled('div')(({ theme }) => ({
	'&  .navigation': {
		padding: 0,
		borderTop: `1px solid ${theme.palette.divider}`
	},
	'&  .base-list-item': {
		padding: '20px 32px',
		margin: 0,
		borderRadius: 0,
		alignItems: 'start',
		borderBottom: `1px solid ${theme.palette.divider}`,
		'&.active': {
			backgroundColor: `${alpha(theme.palette.primary.main, 0.1)}!important`,
			'&  .base-list-item-icon': {
				color: `${theme.palette.primary.main}!important`
			},
			'&  .base-list-item-text-primary': {
				color: `${theme.palette.primary.main}!important`
			}
		}
	},
	'&  .base-list-item-text-primary': {
		fontSize: 13,
		fontWeight: '500'
	},
	'&  .base-list-item-text-secondary': {
		fontSize: 12,
		whiteSpace: 'normal',
		fontWeight: '400'
	}
}));

function SettingsSidebarContent(props) {
	const { className, onSetSidebarOpen } = props;
	return (
    <Root>
      <div className={clsx('m-32 mr-24 flex items-center justify-between sm:my-40', className)}>
        <Typography className="text-4xl font-extrabold leading-none tracking-tight"> Settings</Typography>
        <Hidden lgUp>
          <IconButton
            onClick={() => onSetSidebarOpen(false)}
            aria-label="close left sidebar"
            size="small"
          >
            <BASESvgIcon>heroicons-outline:x-mark</BASESvgIcon>
          </IconButton>
        </Hidden>
      </div>
      <BASENavigation navigation={SettingsNavigation.children} />
    </Root>
	);
}

export default SettingsSidebarContent;